$(document).on('turbolinks:load', function () {

  let empKpiLocationSelect = $("#employee_kpi_location_id");
  let empKpiEmployeeSelect = $("#employee_kpi_employee_id");
  let url = '/api/employees/by_location_id/';

  if (empKpiLocationSelect.length && empKpiEmployeeSelect.length) {
    empKpiLocationSelect.on('change', function (event) {
      empKpiEmployeeSelect.empty();
      let locId = $("select#employee_kpi_location_id option:selected").val();
      $.get(url + locId, function (data) {
        updateEmployeeData(data);
      });
    });
  }

  function updateEmployeeData(data) {
    $.each(data.employees, function (key, value) {
      empKpiEmployeeSelect.append($("<option></option>")
        .attr("value", value.id).text(value.name));
    });
  }

  let importDataEmployeeKpiUploadFile = $('#import-data-employee-kpi-upload-file');
  if (importDataEmployeeKpiUploadFile.length) {
    importDataEmployeeKpiUploadFile.change(function(){
      $('#overlay-on-submit-layer-js').removeClass("d-none");
      $('#import-data-employee-kpi-upload-file-form').trigger('submit');
    });
  }
});